import { usePWA } from '../context/PWAContext';
import AppLayout from './AppLayout';

// Higher-order component to wrap pages in app mode with AppLayout
const withAppLayout = (WrappedComponent, title) => {
  return function WithAppLayoutWrapper(props) {
    const { isStandalone } = usePWA();
    
    if (isStandalone) {
      return (
        <AppLayout title={title}>
          <div className="pb-4">
            <WrappedComponent {...props} hideNavigation={true} />
          </div>
        </AppLayout>
      );
    }
    
    return <WrappedComponent {...props} />;
  };
};

export default withAppLayout;
